import React from "react";

// Resume-related imports are intentionally commented out
// import { AiOutlineCloudDownload } from "react-icons/ai";
// import CallToAction from "../shared/CallToAction";

import {
    FaJava,
    FaJs,
    FaPython,
    FaDatabase,
    FaHtml5,
    FaCss3Alt,
    FaReact,
    FaGithub,
    FaLinux,
} from "react-icons/fa";

import {
    SiCsharp,
    SiMysql,
    SiMongodb,
    SiSpringboot,
    SiDotnet,
} from "react-icons/si";

import Section from "../shared/section";

import "./style.scss";

const Skills = () => {
    const skillsData = [
        { icon: FaJava, name: "Java" },
        { icon: FaJs, name: "JavaScript" },
        { icon: FaPython, name: "Python" },
        { icon: SiCsharp, name: "C#" },
        { icon: FaDatabase, name: "SQL" },
        { icon: SiMysql, name: "MySQL" },
        { icon: SiMongodb, name: "MongoDB" },
        { icon: FaHtml5, name: "HTML" },
        { icon: FaCss3Alt, name: "CSS" },
        { icon: FaReact, name: "React" },
        { icon: FaGithub, name: "GitHub" },
        { icon: FaLinux, name: "Linux" },
        { icon: SiSpringboot, name: "Spring Boot" },
        { icon: SiDotnet, name: ".NET Core" },
    ];

    return (
        <Section background="dark" id="skills">
            <div className="skills-content-wrapper">

                <h2 className="section-title">
                    TECH STACK
                </h2>

                <div className="skills-grid">
                    {skillsData.map((skill, index) => {
                        const SkillIcon = skill.icon;

                        return (
                            <div
                                key={index}
                                className="skill-item"
                            >
                                <SkillIcon className="skill-icon" />

                                <span className="skill-name">
                                    {skill.name}
                                </span>
                            </div>
                        );
                    })}
                </div>

            </div>
        </Section>
    );
};

export default Skills;